import { Stack } from "@mui/material";
import MDTypography from "components/MDTypography";
import React from "react";

function Comments({ comments }) {
  return (
    comments?.length > 0 &&
    comments?.map((comment) => (
      <Stack mt={2}>
        <MDTypography>Comment By {comment?.User?.name}:</MDTypography>
        <MDTypography pl={2}>{comment.comment}</MDTypography>
      </Stack>
    ))
  );
}

export default Comments;
